import { createContext, useContext, useState, type ReactNode } from "react";

interface ChatContextType {
  activeConversationId: string | null;
  isOpen: boolean;
  openChat: (conversationId: string | null) => void;
  closeChat: () => void;
  minimizeChat: () => void;
}

const ChatContext = createContext<ChatContextType | null>(null);

export const useChat = () => {
  const ctx = useContext(ChatContext);
  if (!ctx) throw new Error("useChat must be used within ChatProvider");
  return ctx;
};

export const ChatProvider = ({ children }: { children: ReactNode }) => {
  const [activeConversationId, setActiveConversationId] = useState<string | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const openChat = (conversationId: string | null) => {
    setActiveConversationId(conversationId);
    setIsOpen(true);
  };

  const closeChat = () => {
    setActiveConversationId(null);
    setIsOpen(false);
  };

  const minimizeChat = () => {
    setIsOpen(false);
  };

  return (
    <ChatContext.Provider value={{ activeConversationId, isOpen, openChat, closeChat, minimizeChat }}>
      {children}
    </ChatContext.Provider>
  );
};
